__turbopack_context__.v({
  "className": "figtreefont_14367d43-module__b_0Maq__className",
  "variable": "figtreefont_14367d43-module__b_0Maq__variable",
});
